<template>
    <v-layout row wrap>
        <v-layout class="mx-6" row wrap v-if="!isOld && extra_traveller">

            <confirmation-header-text class="ml-1" icon="mdi-account-multiple"
                                      text="Marriage Details"></confirmation-header-text>
            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="extra_traveller.gender"
                        title="Gender"/>
            </v-flex>
            <v-flex md3 xs6>
                <list-item-detail
                        :sub_title="extra_traveller.full_name"
                        title="Name"/>
            </v-flex>
            <v-flex md3 xs6>
                <list-item-detail :sub_title="extra_traveller.full_address"
                                  :title="'Address of ' + extra_traveller.full_name"/>
            </v-flex>
            <v-flex md3 xs6>
                <list-item-detail :sub_title="extra_traveller.document_number"
                                  :title="'Citizenship Number of ' + extra_traveller.full_name"/>
            </v-flex>

            <v-flex md3 xs6>
                <list-item-detail :sub_title="extra_traveller.dob"
                                  :title="'Date of Birth(BS) of ' + extra_traveller.full_name"/>
            </v-flex>
            <v-flex md3 xs6>
                <list-item-detail :sub_title="application_data.date_of_marriage"
                                  title="Date of Marriage"/>
            </v-flex>
            <v-flex md3 xs6>
                <list-item-detail :sub_title="application_data.place_of_marriage"
                                  title="Place of Marriage"/>
            </v-flex>

        </v-layout>

        <v-layout class="mx-6" row v-else wrap>
            <confirmation-header-text class="ml-2" icon="mdi-account-multiple"
                                      text="Marriage Details"></confirmation-header-text>
            <v-flex md3 xs6 v-if="application_data">
                <list-item-detail
                        :sub_title="application_data.spouse_name"
                        title="Spouse Name"/>
            </v-flex>
            <v-flex md3 xs6 v-if="application_data">
                <list-item-detail
                        :sub_title="application_data.marriage_date"
                        title="Marriage Date"/>
            </v-flex>
            <v-flex md3 xs6 v-if="application_data">
                <list-item-detail :sub_title="application_data.marriage_place"
                                  title="Place of Marriage"/>
            </v-flex>
            <v-flex md3 xs6 v-if="application_data">
                <list-item-detail :sub_title="application_data.spouse_address"
                                  title="Spouse Address"/>
            </v-flex>

            <v-flex md3 xs6 v-if="application_data">
                <list-item-detail :sub_title="application_data.spouse_citizenship_district"
                                  title="Spouse citizenship & issued district"/>
            </v-flex>

        </v-layout>

    </v-layout>

</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import FileDisplay from "../../FileDisplay";
    import FileListItemDetail from "../../FileListItemDetail";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            },
            extra_traveller() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.extra_traveller;
            },
            isOld() {
                return this.$store.state.VisaRequestSingle.visaRequest.old;
            },
        },
        components: {
            ListItemDetail, ConfirmationHeaderText, FileDisplay, FileListItemDetail
        }
    };
</script>
